import { gql, useQuery } from '@provision/graphql-client';
import { isNullish } from 'remeda';
import { useGlobalStore } from 'src/store';

const GET_PARTNER_INVOICES = gql`
  query GetPartnerInvoices($params: GetPartnerInvoicesInput!) {
    getPartnerInvoices(params: $params) {
      invoices {
        id
        number
        status
        total
        created
        hostedInvoiceUrl
      }
    }
  }
`;

export interface PartnerInvoice {
  id: string;
  number?: string | null;
  status: string;
  total: number;
  created: number;
  hostedInvoiceUrl?: string | null;
}

interface GetPartnerInvoicesResponse {
  getPartnerInvoices: {
    invoices: PartnerInvoice[];
  };
}

interface GetPartnerInvoicesVariables {
  params: {
    partnerId: number;
  };
}

export const usePartnerInvoices = () => {
  const selectedPartnerId = useGlobalStore.use.selectedPartnerId();

  const { data, loading, error, refetch } = useQuery<
    GetPartnerInvoicesResponse,
    GetPartnerInvoicesVariables
  >(GET_PARTNER_INVOICES, {
    variables: {
      params: {
        partnerId: selectedPartnerId ?? 0,
      },
    },
    skip: isNullish(selectedPartnerId),
    fetchPolicy: 'network-only',
  });

  return {
    invoices: data?.getPartnerInvoices?.invoices ?? [],
    loading,
    error,
    refetch,
  };
};
